var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBluePen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.25315 2.47487L0.0607657 11.6673V13.7886H2.18209L11.3745 4.59619L9.25315 2.47487ZM10.6674 1.06066L12.7887 3.18198L13.8493 2.12132L11.728 0L10.6674 1.06066Z",
    fill: "#366EFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluePen);
export default __webpack_public_path__ + "static/media/blue-pen.205548de7f396168337260f3d60afd92.svg";
export { ForwardRef as ReactComponent };